import { OpChangeState, Enums } from '../common/enums'

import { ObjectCustomString } from '../../models/util/object-custom-string'

import { OpDataTypeClass } from '../core/op-data-type-class'
import { OpDescr } from '../core/op-descr'
import { OpUnit } from '../core/op-unit'
import { OpReferenceType } from '../core/op-reference-type'
import { OpReport } from './op-report'

import { IOpChangeState, IJsonSerializable } from '../util/interfaces'

export class OpReportParam implements IOpChangeState, IJsonSerializable {

    // Properties

    public idReportParam: number
    public idReport: number
    public fieldName: string
    public idDescr: number
    public idUnit: number
    public idReferenceType: number
    public idDataTypeClass: number
    public isInputParam: boolean
    public isVisible: boolean
    public defaultValue: any
    public colorBg: string
    public format: string

    // Properties End


    // Navigational Properties

    public report: OpReport
    public descr: OpDescr
    public unit: OpUnit
    public reference: OpReferenceType
    public dataTypeClass: OpDataTypeClass

    // Navigational Properties End


    // Custom Properties

    public value: any

    // Custom Properties End


    constructor(opObj: any) {
        this.fromJSON(opObj)
    }


    //IOpChangeState Implementation

    public opState: Enums.OpChangeState

    //IOpChangeState Implementation End


    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idReportParam = opObj.ID_REPORT_PARAM
            this.idReport = opObj.ID_REPORT
            this.fieldName = opObj.FIELD_NAME
            this.idDescr = opObj.ID_DESCR
            this.idUnit = opObj.ID_UNIT
            this.idReferenceType = opObj.ID_REFERENCE
            this.idDataTypeClass = opObj.ID_DATA_TYPE_CLASS
            this.isInputParam = opObj.IS_INPUT_PARAM
            this.isVisible = opObj.IS_VISIBLE
            this.defaultValue = opObj.DEFAULT_VALUE
            this.colorBg = opObj.COLOR_BG
            this.format = opObj.FORMAT

            if (opObj._Report) {
                this.report = new OpReport(opObj._Report)
            }

            if (opObj._Descr) {
                this.descr = new OpDescr(opObj._Descr)
            }

            if (opObj._Unit) {
                this.unit = new OpUnit(opObj._Unit)
            }

            if (opObj._Reference) {
                this.reference = new OpReferenceType(opObj._Reference)
            }

            if (opObj._DataTypeClass) {
                this.dataTypeClass = new OpDataTypeClass(opObj._DataTypeClass)
            }

            this.value = opObj.value

            this.opState = opObj.OpState
        } else {
            this.idReportParam = 0
            this.opState = OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_REPORT_PARAM: this.idReportParam,
            OpState: this.opState
        }
    }

    public toString() {
        if (this.descr)
            return this.descr.description
        
        return 'ReportParam [' + this.idReportParam + ']'
    }
}